import React, { useEffect, useRef, useState } from "react";
import IPcamera from "../../../Assets/Images/ipCamera.png";
import {
  AddItemContainer,
  ApplyFormInput,
  Error,
  ImageInput,
  ImageInputArea,
  InputDiv,
  Label,
  Select,
  SubmitButton,
  UploadButton,
  UploadInput,
} from "../../../styles/styles";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";

const GenInventory = ({ setGoto, details }) => {
  const hiddenImageInput = useRef(null);
  const hiddenDocInput = useRef(null);
  const [imgFile, setImgFile] = useState("");
  const [docFile, setDocFile] = useState("");
  const [edit, setEdit] = useState(false);
  const [required, setRequired] = useState(true);
  // const [imgFileError, setImgFileError] = useState("");
  // const [docFileError, setDocFileError] = useState("");
  // const [fileUrl, setFileUrl] = useState(null);
  const handleClick = (param) => {
    if (param === "image") {
      hiddenImageInput.current.click();
    } else {
      hiddenDocInput.current.click();
    }
  };
  const handleImgInputChange = (e) => {
    const imgFileUploaded = e.target.files[0];
    setImgFile(imgFileUploaded);
    // setImgFileError("");
  };
  const handleDocInputChange = (e) => {
    const docFileUploaded = e.target.files[0];
    setDocFile(docFileUploaded);
    // setDocFileError("");
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data) => {
    console.log(data, { imgFile }, { docFile });
  };
  let { info, location, name, sku, available } = details;
  useEffect(() => {
    if (details.info) {
      setEdit(true);
      setRequired(false);
    }
  }, [details]);
  return (
    <AddItemContainer>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col md={3} xs={12}>
            <InputDiv>
              <Label style={{ width: "70%", margin: "0 auto" }}>
                Item Image
              </Label>
              <ImageInputArea onClick={() => handleClick("image")}>
                <ImageInput className="img-fluid" src={IPcamera} alt="" />
              </ImageInputArea>
              <div className="text-center">
                <UploadButton onClick={() => handleClick("image")}>
                  + Upload Image
                </UploadButton>
                <input
                  ref={hiddenImageInput}
                  onChange={handleImgInputChange}
                  style={{ display: "none" }}
                  type="file"
                />
              </div>
            </InputDiv>
          </Col>
          <Col md={9} xs={12} className="" style={{ paddingRight: "30px" }}>
            <Row className="w-100 justify-content-center m-0">
              <Col md={4} xs={12}>
                <InputDiv>
                  <Label>Item Name</Label>
                  <ApplyFormInput
                    placeholder=""
                    defaultValue={edit === true ? name : ""}
                    {...register("item_name", { required: required })}
                  />
                  {errors.item_name && <Error>Item name is required</Error>}
                </InputDiv>
              </Col>
              <Col md={4} xs={12}>
                <InputDiv>
                  <Label>Item Qty.</Label>
                  <ApplyFormInput
                    placeholder=""
                    defaultValue={edit ? available : null}
                    {...register("item_quantity", {
                      required: required,
                      pattern: /^\d+$/i,
                    })}
                  />
                  {errors.item_quantity && <Error>Give a valid quantity</Error>}
                </InputDiv>
              </Col>
              <Col md={4} xs={12}>
                <InputDiv>
                  <Label>P.O. Number</Label>
                  <ApplyFormInput
                    placeholder=""
                    defaultValue={edit ? sku : null}
                    {...register("po_number", {
                      required: required,
                      pattern: /([1-9]\d*)/g,
                    })}
                  />
                  {errors.po_number && (
                    <Error>Post office number is required</Error>
                  )}
                </InputDiv>
              </Col>
            </Row>
            <Row className="w-100 justify-content-center m-0">
              <Col md={4} xs={12}>
                <InputDiv>
                  <Label>Date</Label>
                  <ApplyFormInput
                    placeholder=""
                    type="datetime"
                    defaultValue={edit ? "03/12/22" : null}
                    {...register("date", { required: required })}
                  />
                  {errors.date && <Error>Date is required</Error>}
                </InputDiv>
              </Col>
              <Col md={4} xs={12}>
                <InputDiv>
                  <Label>Supplier Name</Label>
                  <ApplyFormInput
                    placeholder=""
                    defaultValue={edit ? "Mr. Snowden" : null}
                    {...register("supplier", {
                      required: required,
                    })}
                  />
                  {errors.supplier && <Error>Supplier name is required</Error>}
                </InputDiv>
              </Col>
              <Col md={4} xs={12}>
                <InputDiv>
                  <Label>Received Date</Label>
                  <ApplyFormInput
                    type="datetime"
                    placeholder=""
                    defaultValue={edit ? "2/2/21" : null}
                    {...register("received_date", {
                      required: required,
                    })}
                  />
                  {errors.received_date && (
                    <Error>Received date number is required</Error>
                  )}
                </InputDiv>
              </Col>
            </Row>
            <Row className="w-100  m-0">
              <Col md={6} xs={12}>
                <InputDiv>
                  <Label>Warehouse</Label>
                  <Select
                    defaultValue={edit ? location : null}
                    {...register("warehouse", {
                      required: required,
                    })}
                  >
                    {!info && <option className="d-none" value=""></option>}
                    <option value="ware-1"> WareHouse-1 </option>
                    <option value="ware-2"> WareHouse-2 </option>
                    <option value="ware-3"> WareHouse-3 </option>
                  </Select>
                </InputDiv>
              </Col>
              <Col md={6} xs={12}>
                <InputDiv>
                  <Label>Delivery Proof</Label>
                  <UploadButton outline onClick={() => handleClick("doc")}>
                    + Upload Document
                  </UploadButton>
                  <UploadInput
                    ref={hiddenDocInput}
                    className="px-3 py-2"
                    onChange={handleDocInputChange}
                    style={{ display: "none" }}
                    type="file"
                  />
                </InputDiv>
              </Col>
              <Col md={12} xs={12}>
                <InputDiv>
                  <Label>Remarks</Label>
                  <ApplyFormInput
                    type="text"
                    defaultValue={edit ? `${name} , ${location}` : null}
                    {...register("remarks")}
                  />
                </InputDiv>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="text-center my-lg-5">
          <SubmitButton type="submit" value="Save" />
        </div>
      </form>
    </AddItemContainer>
  );
};

export default GenInventory;
